export enum LongRunningActionState {
  Queued,
  InProgress,
  Complete
}

export enum LongRunningActionType {
  DeleteSites
}

export interface ILongRunningActionProgress {
  id: string;
  type: LongRunningActionType;
  state: LongRunningActionState;
  percentComplete: number;
}

export interface ILongRunningAction extends ILongRunningActionProgress {
  response: any; // TODO: Is this an IResponse or an IResult?
  succeeded: boolean;
}
